import type { FC } from 'react'

import { ArrowRight } from 'lucide-react'
import ButtonLink from '@/components/landing/button-link'
import HeroStage from '@/components/landing/hero-stage'
import TrajectoryArc from '@/components/landing/trajectory-arc'
import { Accent } from '@/components/landing/section-heading'
import { LINKS } from '@/constants/kinematic'

const Hero: FC = () => {
    return (
        <section id='hero' aria-labelledby='hero-title' className='relative isolate overflow-hidden pb-20 pt-28 md:pb-28 md:pt-36'>
            <div aria-hidden='true' className='pointer-events-none absolute inset-0 -z-10'>
                <div className='grid-lines absolute inset-0 [mask-image:radial-gradient(ellipse_75%_55%_at_50%_0%,black,transparent)]' />
                <div className='absolute left-1/2 top-[60%] h-[560px] w-[min(1200px,95vw)] -translate-x-1/2 rounded-full bg-ember/[0.15] blur-[140px]' />
                <div className='noise absolute inset-0 opacity-[0.05] mix-blend-overlay' />
            </div>

            <TrajectoryArc className='pointer-events-none absolute right-[3%] top-24 -z-10 hidden w-[400px] xl:block 2xl:right-[8%] 2xl:w-[440px]' />

            <div className='mx-auto max-w-[1320px] px-5 md:px-8'>
                <a
                    href='#pricing'
                    className='inline-flex items-center gap-2.5 rounded-full border border-white/10 bg-white/[0.03] py-1.5 pl-2.5 pr-3.5 text-[13px] text-steel backdrop-blur transition-colors hover:border-white/20 hover:text-bone'
                >
                    <span className='relative flex size-2'>
                        <span aria-hidden='true' className='absolute inline-flex size-full animate-ping rounded-full bg-mint opacity-60 motion-reduce:hidden' />
                        <span className='relative inline-flex size-2 rounded-full bg-mint' />
                    </span>
                    Sandbox is free. You pay when you go live.
                    <ArrowRight aria-hidden='true' className='size-3.5' />
                </a>

                <h1
                    id='hero-title'
                    className='mt-8 text-[clamp(3rem,11vw,10.5rem)] font-semibold leading-[0.86] tracking-[-0.04em] text-bone stretch-condensed'
                >
                    <span className='block'>
                        Thirteen originals.
                    </span>
                    <span className='block'>
                        Every bet, <Accent className='pr-[0.04em] text-ember'>proven.</Accent>
                    </span>
                </h1>

                <div className='mt-10 grid gap-8 lg:mt-12 lg:grid-cols-12 lg:items-end'>
                    <p className='text-lg leading-relaxed text-steel md:text-xl lg:col-span-6'>
                        Put thirteen original casino games on your site. You serve them from <span className='text-bone'>your own game server on Cloudflare</span>, and your players can check <span className='text-bone'>every bet in the browser</span>.
                    </p>

                    <div className='flex flex-wrap items-center gap-3 lg:col-span-6 lg:justify-end'>
                        <ButtonLink href={LINKS.signUp} external>
                            Start free in sandbox
                        </ButtonLink>

                        <ButtonLink href={LINKS.lobby} variant='ghost' external>
                            Play the games
                        </ButtonLink>
                    </div>
                </div>

                <div className='mt-14 md:mt-16'>
                    <HeroStage />
                </div>
            </div>
        </section>
    )
}

export default Hero
